'use client';

import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import type { SxProps, Theme } from '@mui/material/styles';
import { EBV_TRAIT_INFO_ICON_SIZE } from './ebvTraitExplanations';
import type { TraitExplanationEntry } from './ebvTraitExplanations';

type EbvTraitInfoIconProps = {
  label: string;
  entry: TraitExplanationEntry;
  onClick: (
    event: React.MouseEvent<HTMLElement>,
    entry: TraitExplanationEntry,
  ) => void;
  iconSize?: number;
  sx?: SxProps<Theme>;
};

export default function EbvTraitInfoIcon({
  label,
  entry,
  onClick,
  iconSize = EBV_TRAIT_INFO_ICON_SIZE,
  sx,
}: EbvTraitInfoIconProps) {
  return (
    <IconButton
      size="small"
      onClick={(event) => onClick(event, entry)}
      aria-label={`Explain ${label}`}
      sx={{
        p: 0.25,
        color: 'text.secondary',
        flexShrink: 0,
        '&:hover': { color: 'text.primary' },
        ...sx,
      }}
    >
      <InfoOutlinedIcon sx={{ fontSize: iconSize }} />
    </IconButton>
  );
}
